import { userInfo } from '@apollo-internal/cache';
import { useReactiveVar } from '@apollo/client';
import ApolloError from '@shared/components/ApolloError';
import React, { useContext } from 'react';
import PrivilegeNames from '../../../constants/privilegeNames';
import { Page } from '../../layout';
import { Breadcrumb } from '../../shared/components/breadcrumb/Breadcrumb';
import PageInstructions from '../../shared/components/PageInstructions';
import { LegalDocumentsContext } from '../contexts/LegalDocumentsContext';
import AddLegalDocumentForm from './AddLegalDocumentForm';
import LegalDocumentsTable from './LegalDocumentsTable';
import { canUserAccessSeveralOrganization } from '@shared/services/userAccessibilityService';

const TITLE = 'Legal Documents';
const DESCRIPTION =
  'This report provides the Organization Unit Legal Documents. ' +
  'Results are in reverse chronological order. ' +
  'Selecting the view link will view that legal document.';

const LegalDocuments = () => {
  const { legalDocuments, organization, deleteLegalDocument, loading, error } =
    useContext(LegalDocumentsContext);

  const currentUserInfo = useReactiveVar(userInfo);

  const breadcrumbPathItems = [{ name: TITLE, url: '' }];

  const canAddLegalDocument = currentUserInfo.Privileges.includes(
    PrivilegeNames.LegalDocuments_Add
  );

  const annotationItems =
    canUserAccessSeveralOrganization(currentUserInfo.Tier) && organization
      ? [organization.Name]
      : [];

  if (error) {
    return <ApolloError />;
  }

  return (
    <Page title={TITLE} className='legal-documents'>
      <Breadcrumb pathItems={breadcrumbPathItems} annotationItems={annotationItems} />
      <PageInstructions title={TITLE} description={DESCRIPTION} />
      <LegalDocumentsTable data={legalDocuments} loading={loading} onDelete={deleteLegalDocument} />
      {canAddLegalDocument && <AddLegalDocumentForm />}
    </Page>
  );
};

export default LegalDocuments;
